import './App.css';
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import AppRouter from './router/Router';

function App() {
  return (
    <Router>
      <AppRouter />
    </Router>
  );
}

export default App;
